if (!customElements.get('sophia-size-guide')) {
  customElements.define('sophia-size-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.dialog = this.querySelector('dialog');
      this.trigger = this.querySelector('[data-size-guide-open]');
      this.trigger?.addEventListener('click', () => {
        if (!this.dialog?.open) this.dialog?.showModal();
      });
      this.querySelector('[data-size-guide-close]')?.addEventListener('click', () => this.dialog?.close());
      this.dialog?.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      });
      this.dialog?.addEventListener('close', () => this.trigger?.focus());
      const pick = (i) => {
        this.querySelectorAll('[data-size-pick]').forEach((b) => { const on = b.dataset.sizePick === String(i); b.classList.toggle('is-active', on); b.setAttribute('aria-selected', on); });
        this.querySelectorAll('[data-size-row]').forEach((r) => r.classList.toggle('is-active', r.dataset.sizeRow === String(i)));
      };
      this.querySelectorAll('[data-size-pick]').forEach((b) => b.addEventListener('click', () => pick(b.dataset.sizePick)));
      this.querySelectorAll('[data-size-row]').forEach((r) => r.addEventListener('click', () => pick(r.dataset.sizeRow)));
    }
  });
}
